import { render, staticRenderFns } from "./OtaProgress.vue?vue&type=template&id=37105e0e"
import script from "./OtaProgress.vue?vue&type=script&lang=js"
export * from "./OtaProgress.vue?vue&type=script&lang=js"
import style0 from "./OtaProgress.vue?vue&type=style&index=0&id=37105e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports